// extracted by mini-css-extract-plugin
module.exports = {"whoIam":"WhyIAm_whoIam__3wsC5","title":"WhyIAm_title__Z2V15","blocks":"WhyIAm_blocks__2q6Fq"};